<template>
  <v-container fluid class="footer-container">
    <v-container class="py-lg-10 py-8">
<!--      <div class="chatbox background-green-light rounded-circle pa-3">-->
<!--        <a href="https://wa.link/0rjmyg">-->
<!--         <v-img src="/wsIcon.svg" max-width="40" contain></v-img></a>-->
<!--      </div>-->
      <v-row>
        <v-col cols="12" lg="2" class="d-none d-lg-flex align-start">
          <v-img src="/Logo.svg" max-width="72" contain></v-img>
        </v-col>
        <v-col cols="12" lg="10" class="d-none d-lg-flex">
          <v-row>
            <v-col cols="12" lg="3">
              <h6
                class="text-lg-body-1 text-navy font-weight-bold"
                v-html="$t('footer.departments')"
              ></h6>
              <hr class="mt-lg-2 mb-lg-5" />
              <v-row
                class="mx-lg-0 my-lg-3"
                v-for="(department, index) in departments.slice(0,8)"
                :key="index"
              >
                <router-link
                  :to="{
                    path: `/areas/doctors-and-departments?department=${department.slug}`,
                  }"
                  class="text-navy text-lg-body-1 font-weight-light"
                >
                  {{ department.name }}
                </router-link>
              </v-row>
            </v-col>
            <v-col cols="12" lg="3">
              <h6
                class="text-lg-body-1 text-navy font-weight-bold mt-lg-n6"
                v-html="$t('footer.pathologiesMostConsulted')"
              ></h6>
              <hr class="mt-lg-2 mb-lg-5" />
              <v-row
                class="mx-lg-0 my-lg-3"
                v-for="(pathology, index) in pathologies.slice(0,8)"
                :key="index"
              >
                <router-link
                  :to="{
                    path: `/areas/pathologies-more-consulted?pathology=${pathology.slug}`,
                  }"
                  class="text-navy text-lg-body-1 font-weight-light"
                >
                  {{ pathology.name }}
                </router-link>
              </v-row>
            </v-col>
            <v-col cols="12" lg="3">
              <h6
                class="text-lg-body-1 text-navy font-weight-bold"
                v-html="$t('footer.institution')"
              ></h6>
              <hr class="mt-lg-2 mb-lg-5" />
              <v-row
                class="mx-lg-0 my-lg-3"
                v-for="(institution, index) in institutions"
                :key="index"
              >
                <a :href="institution.path">
                  <h6 class="text-navy text-lg-body-1 font-weight-light">
                    {{ institution.name }}
                  </h6>
                </a>
              </v-row>
            </v-col>
            <v-col cols="12" lg="3">
              <h6
                class="text-lg-body-1 text-navy font-weight-bold"
                v-html="$t('footer.followUs')"
              ></h6>
              <hr class="mt-lg-2 mb-lg-5" />
              <v-row class="mx-lg-0">
                <v-col
                  cols="auto"
                  v-for="(item, index) in redes"
                  :key="index"
                  class="px-lg-2"
                >
                  <a :href="item.link" target="_blank">
                    <div class="d-flex justify-center align-center">
                      <v-img
                        :src="item.icon"
                        contain
                        width="30"
                        height="30"
                      ></v-img>
                    </div>
                  </a>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <hr class="my-lg-5 mb-5 d-none d-lg-flex" />
      <v-row class="mx-lg-0 d-lg-none justify-center">
        <v-col
          cols="auto"
          v-for="(item, index) in redes"
          :key="index"
          class="px-lg-2"
        >
          <a :href="item.link" target="_blank">
            <div class="d-flex justify-center align-center">
              <v-img :src="item.icon" contain width="30" height="30"></v-img>
            </div>
          </a>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="6">
          <h6
            class="
              text-navy text-lg-body-2
              font-weight-light
              text-center text-lg-left
            "
          >
            <span class="font-weight-bold text-uppercase">incocegla</span>
            © {{ $t("footer.allRightsReserved") }}
            {{ new Date().getFullYear() }}
          </h6>
        </v-col>
        <v-col cols="12" lg="6" class="pt-0 pt-lg-3">
          <v-row class="mx-lg-0 justify-lg-end justify-center">
            
            <v-col cols="auto" class="px-1">
              <a href="https://mixart.do/home" target="_blank">
                <v-img src="/FirmaNegra.svg" width="70" contain></v-img>
              </a>
            </v-col>
            <v-col cols="auto" class="px-0">
              <a href="https://4bits.com.do/" target="_blank">
                <h6 class="text-navy text-lg-body-2 font-weight-light">
                  in collaboration with 4bits
                </h6>
              </a>
            </v-col>
            <v-col cols="auto" class="px-1 pt-4">
              <a href="https://4bits.com.do/" target="_blank">
                <v-img src="/Logo4BITS.svg" width="9"></v-img>
              </a>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import Department from "../services/department";
import Pathology from "../services/pathology";

export default {
  data() {
    return {
      departments: [],
      pathologies: [],
      institutions: [
        {
          name: this.$t("footer.aboutIncocegla"),
          path: "/about-us/",
        },
        {
          name: this.$t("footer.glaucomaClub"),
          path: "/about-us/glaucoma-club",
        },
        {
          name: this.$t("footer.incoceglaFoundation"),
          path: "/about-us/incocegla-foundation",
        },
      ],
      redes: [
        {
          icon: "/fb.svg",
          link: "https://www.facebook.com/incocegla/",
        },
        {
          icon: "/ig.svg",
          link: "https://www.instagram.com/incocegla/?hl=es",
        },
        {
          icon: "/tw.svg",
          link: "https://twitter.com/incocegla?lang=es",
        },
        {
          icon: "/yt.svg",
          link: "https://www.youtube.com/channel/UC-4D85UdwvS_6IHxnxqbXCQ",
        },
      ],
    };
  },
  async created() {
    this.departments = await Department.getDepartments();
    this.departments.sort((a, b) => (a.name > b.name ? 1 : -1));
    this.pathologies = await Pathology.getPathologies();
    this.pathologies.sort((a, b) => (a.name > b.name ? 1 : -1));
  },
  computed: {
    ...mapGetters("departments", ["getDepartments"]),
    ...mapGetters("pathologies", ["getPathologies"]),
  },
};
</script>
